import actions from './global/actions';
import mutations from './global/mutations';
import getters from './global/getters';

// Article State
const state = {
  theme: 'dark',
  redirect: '',
  userProfile: {},
  fastHistory: [],
  msgBox: {},
  templateFiles: '',
  chatGptAsk: [],
  chatGptResponse: [],
  notification: {
    page: 1,
    count: 0,
    list: [],
  },
  eproModuleQuesList: [],
  // msgBox: {
  //   type: '',
  //   content: '',
  // }
  // user: {
  //   code: '',
  //   lineid: '',
  //   permission: '',
  //   teamName: ''
  // }
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
  strict: true,
};
